import { useState, useCallback } from 'react';
import { motion } from 'framer-motion';
import styles from './CopyButton.module.css';

type CopyButtonProps = {
  text: string;
  label?: string;
  onCopy?: () => void;
  className?: string;
};

/**
 * Кнопка для копирования текста в буфер обмена
 */
export const CopyButton = ({
  text,
  label = 'Копировать',
  onCopy,
  className = '',
}: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      onCopy?.();

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
        setCopied(true);
        onCopy?.();

        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch {
        // Игнорируем ошибку
      } finally {
        document.body.removeChild(textArea);
      }
    }
  }, [text, onCopy]);

  return (
    <motion.button
      type="button"
      onClick={handleCopy}
      className={`${styles.button} ${className}`}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      aria-label={copied ? 'Скопировано' : label}
    >
      <span className={styles.icon}>
        {copied ? '✓' : '📋'}
      </span>
      <span className={styles.text}>
        {copied ? 'Скопировано!' : label}
      </span>
    </motion.button>
  );
};
